(() => {
  const MAX_DOTS = 19;

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  // 将 N 张图映射成最多 19 个点：均匀取样 slide index
  function buildMap(totalSlides) {
    const dots = Math.min(totalSlides, MAX_DOTS);
    if (dots <= 1) return [0];

    const arr = [];
    for (let i = 0; i < dots; i++) {
      arr.push(Math.round((i * (totalSlides - 1)) / (dots - 1)));
    }

    // 去重 + 保证递增（避免 round 重复导致点数变少）
    const out = [];
    let last = -1;
    for (let i = 0; i < arr.length; i++) {
      let v = clamp(arr[i], 0, totalSlides - 1);
      if (v <= last) v = Math.min(totalSlides - 1, last + 1);
      out.push(v);
      last = v;
    }
    // 倒序修正上限
    for (let i = out.length - 1; i >= 0; i--) {
      const maxHere = (totalSlides - 1) - (out.length - 1 - i);
      out[i] = Math.min(out[i], maxHere);
    }
    // 再次递增
    for (let i = 1; i < out.length; i++) {
      if (out[i] <= out[i - 1]) out[i] = out[i - 1] + 1;
    }
    return out;
  }

  function nearestSlideIndex(slider, slides) {
    const left = slider.scrollLeft;
    let best = 0;
    let bestDist = Infinity;
    for (let i = 0; i < slides.length; i++) {
      const dist = Math.abs(slides[i].offsetLeft - left);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
    return best;
  }

  function scrollToSlide(slider, slide) {
    const left = slide.offsetLeft - (slider.clientWidth - slide.clientWidth) / 2;
    slider.scrollTo({ left: clamp(left, 0, slider.scrollWidth), behavior: "smooth" });
  }

  function initOne(productInfo) {
    if (productInfo.__dotsInited) return;

    const mediaWrapper = productInfo.querySelector(".product__media-wrapper");
    if (!mediaWrapper) return;

    // Dawn 主图 slider（一般是 ul.product__media-list）
    const slider =
      mediaWrapper.querySelector(".product__media-list") ||
      mediaWrapper.querySelector('[id^="Slider-Gallery-"]');

    if (!slider) return;

    const slides = Array.from(
      slider.querySelectorAll(".product__media-item, .slider__slide, li[data-media-id]")
    ).filter((el) => el.offsetParent !== null || el.getClientRects().length);

    if (slides.length <= 1) return;

    // 创建 dots 容器（放在媒体 wrapper 里，主图下面）
    let dotsWrap = mediaWrapper.querySelector(".product-media-dots");
    if (!dotsWrap) {
      dotsWrap = document.createElement("div");
      dotsWrap.className = "product-media-dots";
      mediaWrapper.appendChild(dotsWrap);
    }

    const map = buildMap(slides.length);

    // 生成 dots
    dotsWrap.innerHTML = "";
    const dots = map.map((slideIndex) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "product-media-dots__btn";
      btn.dataset.slideIndex = String(slideIndex);
      btn.setAttribute("aria-current", "false");
      btn.setAttribute("aria-label", `Go to image ${slideIndex + 1} of ${slides.length}`);
      btn.addEventListener("click", () => {
        const target = slides[slideIndex];
        if (target) scrollToSlide(slider, target);
      });
      dotsWrap.appendChild(btn);
      return btn;
    });

    function setActiveDotBySlide(activeSlideIdx) {
      // 找离当前 slide 最近的 dot
      let bestDot = 0;
      let bestDist = Infinity;
      for (let i = 0; i < map.length; i++) {
        const dist = Math.abs(map[i] - activeSlideIdx);
        if (dist < bestDist) {
          bestDist = dist;
          bestDot = i;
        }
      }
      dots.forEach((b, i) => b.setAttribute("aria-current", i === bestDot ? "true" : "false"));
    }

    // 初始高亮
    setActiveDotBySlide(0);

    // 滚动时更新（滑动切图也会跟随）
    let raf = null;
    slider.addEventListener(
      "scroll",
      () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = null;
          setActiveDotBySlide(nearestSlideIndex(slider, slides));
        });
      },
      { passive: true }
    );

    window.addEventListener("resize", () => {
      setActiveDotBySlide(nearestSlideIndex(slider, slides));
    });

    productInfo.__dotsInited = true;
  }

  function initAll() {
    document.querySelectorAll("product-info").forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // theme editor / section reload
  document.addEventListener("shopify:section:load", initAll);
})();
